import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Button, Card, CardDeck, Col, Media, Row, Spinner } from 'reactstrap';
import clsx from 'clsx';
import { CONTROL_MODAL, useProfileViewDispatch } from 'context/profile-view';

/**
 * Primary UI component for user interaction
 */
export const Wallet = ({ balance, currency, received, send, backgroundColor, isLoadingBalance, ...props }) => {

    const dispatch = useProfileViewDispatch();

    const { t } = useTranslation();

    const onWithdraw = () => {
        dispatch({ type: CONTROL_MODAL, open: 'WITHDRAW' });
    }

    return (
        <Card
            className={clsx('mt-2 p-4 text-white rounded-lg border-0', backgroundColor)}
            {...props}
        >
            <h5 className="text-weight-bold">{t('blockchain.Balance')}</h5>
            <Row className="mt-2">
                <Col md="12" >
                    <span className="h3">{isLoadingBalance ? <Spinner size="sm" /> : balance}</span>
                    <span className="h5">{' '}{currency}</span>
                </Col>
            </Row>
            <Row className="mt-2">
                <Col md="6" >
                    <div className="p-1">
                        <span className="">{t('blockchain.Received')}</span>
                    </div>
                    <div className="p-1">
                        <span><i className="fas fa-long-arrow-alt-up"></i> {received}</span>
                    </div>
                </Col>
                <Col md="6">
                    <div className="p-1">
                        <span className="">{t('blockchain.Send')}</span>
                    </div>
                    <div className="p-1">
                        <span><i className="fas fa-long-arrow-alt-down"></i> {send}</span>
                    </div>
                </Col>
            </Row>

            <div className="walletfooter mt-4">
                <Button block color="default" className="border text-white font-weight-bold" onClick={onWithdraw}>{t('blockchain.Withdraw')}</Button>
            </div>
        </Card>
    );
};

Wallet.propTypes = {
    /**
     * ReceivedAmmount
     */
    received: PropTypes.number,
    /**
     * SendAmount
     */
    send: PropTypes.number,
    /**
     * What background color to use
     */
    backgroundColor: PropTypes.string,
    /**
     * Click handler
     */
    balance: PropTypes.string,
    /**
     * Optional click handler
     */
    currency: PropTypes.string,
};

Wallet.defaultProps = {
    backgroundColor: '#F47B33',
    received: 0,
    send: 0,
    balance: '0',
    currency: 'ETH'
};

export default Wallet;